import React, { useState,useEffect } from 'react';
import PageWrapper from '../PageWrapper';
import $ from 'jquery';

function Treatment() {
	useEffect(() => {
        var headerheight = $('.main-nav').innerHeight();
        if ($(window).scrollTop() > headerheight){
            $('.nav .main-nav').addClass('full-head');
        }
        else {
            $('.nav .main-nav').removeClass('full-head');
        }
    });
    return (
        <PageWrapper title="treatment">
            <div>
            <header class="header">
                <div class="container">
                    <div class="top-dec w-left">
                        <div class="breadcrumbs">
                            <h1>Treatment</h1>
                        </div>
                    </div>              
                </div>
            </header>
            <div className="mdc_treatment_wrap md">
			<div className="container mdc_treatment">
				<div className="row">
					<div className="mdc_treatment_box">
						<div className="mdc_treat_imgtxt mdct_l col-12 col-md-6">
						<div class="mdc_trat_imga"><img  src={require("../../images/treat_img.png")} /></div>
						</div>
						<div className="mdc_treat_imgtxt mdct_r col-12 col-md-6">
							<h2>Cardiology</h2>
							<p>Morbi sed accumsan quam, id tempor eros. Sed sed justo commodo, sagittis urna ac, ornare sem. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nulla non facilisis arcu, id pharetra risus. Pellentesque congue dui justo, ut dignissim justo ultrices id.</p>
							<p>Aliquam lobortis tempor dui, in molestie enim auctor at. Nulla tellus tortor, tincidunt ac dolor nec, convallis laoreet diam.</p>
							<a href="#">Read More <i className="fas fa-long-arrow-alt-right"></i></a>
						</div>
					</div>
					<div className="mdc_treatment_box">
						<div className="mdc_treat_imgtxt mdct_l col-12 col-md-6">
						<div class="mdc_trat_imga"><img  src={require("../../images/treat_img_2.png")} /></div>
						</div>
						<div className="mdc_treat_imgtxt mdct_r col-12 col-md-6">
							<h2>Physiotherapy</h2>
							<p>Morbi sed accumsan quam, id tempor eros. Sed sed justo commodo, sagittis urna ac, ornare sem. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nulla non facilisis arcu, id pharetra risus. Pellentesque congue dui justo, ut dignissim justo ultrices id.</p>
							<p>Aliquam lobortis tempor dui, in molestie enim auctor at. Nulla tellus tortor, tincidunt ac dolor nec, convallis laoreet diam.</p>
							<a href="#">Read More <i className="fas fa-long-arrow-alt-right"></i></a>
						</div>						
					</div>
					<div className="mdc_treatment_box">
						<div className="mdc_treat_imgtxt mdct_l col-12 col-md-6">
						<div class="mdc_trat_imga"><img src={require("../../images/treat_img.png")} /></div>
						</div>
						<div className="mdc_treat_imgtxt mdct_r col-12 col-md-6">
							<h2>Blood test</h2>
							<p>Morbi sed accumsan quam, id tempor eros. Sed sed justo commodo, sagittis urna ac, ornare sem. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nulla non facilisis arcu, id pharetra risus. Pellentesque congue dui justo, ut dignissim justo ultrices id.</p>
							<p>Aliquam lobortis tempor dui, in molestie enim auctor at. Nulla tellus tortor, tincidunt ac dolor nec, convallis laoreet diam.</p>
							<a href="#">Read More <i className="fas fa-long-arrow-alt-right"></i></a>
						</div>
					</div>
					<div className="mdc_treatment_box">
						<div className="mdc_treat_imgtxt mdct_l col-12 col-md-6">
						<div class="mdc_trat_imga"><img src={require("../../images/treat_img.png")} /></div>
						</div>
						<div className="mdc_treat_imgtxt mdct_r col-12 col-md-6">
							<h2>Neurology</h2>
							<p>Morbi sed accumsan quam, id tempor eros. Sed sed justo commodo, sagittis urna ac, ornare sem. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nulla non facilisis arcu, id pharetra risus. Pellentesque congue dui justo, ut dignissim justo ultrices id.</p>
							<p>Aliquam lobortis tempor dui, in molestie enim auctor at. Nulla tellus tortor, tincidunt ac dolor nec, convallis laoreet diam.</p>
							<a href="#">Read More <i className="fas fa-long-arrow-alt-right"></i></a>
						</div>
					</div>
				</div>
			</div>
		</div>
        <div class="mdc_services mb">
			<div class="container">
				<div class="row">
					<div class="mdc_services_item col-12 col-md-4">
						<div class="mdc_item_inner">							
						<div class="mdc_item_inner_a"><svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
								<path class="srv_1" d="m39 17a23 23 0 1 0 23 23 23.026 23.026 0 0 0 -23-23zm-8.625 29.971c-1.792.022-3.095.031-4.047.031a11.291 11.291 0 0 1 -2.708-.1 1.141 1.141 0 0 1 -.689-.7c-.179-.579.056-.889.833-1.919.642-.85 1.837-2.433 3.839-5.327a7.389 7.389 0 0 0 1.188-2.422l.036-.322a2.222 2.222 0 0 0 -4.408-.39 1 1 0 1 1 -1.962-.381 4.222 4.222 0 0 1 8.371.823c0 .109-.012.139-.071.618a9.226 9.226 0 0 1 -1.509 3.212c-1.693 2.447-2.817 3.969-3.52 4.906 1.239 0 2.987-.007 4.621-.028a1.03 1.03 0 0 1 1.013.987 1 1 0 0 1 -.987 1.012zm11.625-3.808h-.771c-.009 1.41-.018 2.508-.021 2.845a1 1 0 0 1 -1 .992h-.008a1 1 0 0 1 -.991-1.008c.007-.86.015-1.826.021-2.829h-5.3a1 1 0 0 1 -.882-1.472c.707-1.321 4.269-7.958 4.98-8.858a1.73 1.73 0 0 1 3.206.987c.037.468.025 4.135 0 7.343h.766a1 1 0 0 1 0 2zm13 3.837a1 1 0 0 1 -1-1l-.019-4.462c.016-2.773-.851-3.2-2.248-3.2-1.609 0-2.733 1.314-2.733 3.2v4.462a1 1 0 0 1 -2 0v-13a1 1 0 0 1 2 0v4.218a4.554 4.554 0 0 1 2.733-.877c3.136 0 4.268 2.067 4.248 5.2l.019 4.459a1 1 0 0 1 -1 1z" />
								<path class="srv_1" d="m35.606 41.163h3.636c.017-2.726.026-5.371.015-6.561-.741 1.225-2.345 4.143-3.651 6.561z" />
								<path class="srv_2" d="m34.868 35.5a1 1 0 0 0 -.372-1.364l-6.496-3.716v-13.42a1 1 0 0 0 -2 0v14a1.167 1.167 0 0 0 .5.868l7 4a1 1 0 0 0 1.368-.368z"/>
								<path class="srv_2" d="m48.017 12.456a1 1 0 1 0 -1.68 1.085 23.055 23.055 0 1 1 -3.85-4.541h-1.487a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -2 0v1.68a24.888 24.888 0 1 0 4.017 4.776z"/><path class="srv_2" d="m27 9a1 1 0 0 0 1-1v-2a1 1 0 0 0 -2 0v2a1 1 0 0 0 1 1z"/><path class="srv_2" d="m26 44v2a1 1 0 0 0 2 0v-2a1 1 0 0 0 -2 0z"/><path class="srv_2" d="m44 26a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 -1 1z"/><path class="srv_2" d="m7 25a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"/></svg></div>
							<h3>24/7 Emergency Care</h3>
							<p>Proin tincidunt eros leo.</p>
						</div>
					</div>
					<div class="mdc_services_item col-12 col-md-4">
						<div class="mdc_item_inner">
						<div class="mdc_item_inner_a"><svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
								<path class="srv_1" d="m39 17a23 23 0 1 0 23 23 23.026 23.026 0 0 0 -23-23zm-8.625 29.971c-1.792.022-3.095.031-4.047.031a11.291 11.291 0 0 1 -2.708-.1 1.141 1.141 0 0 1 -.689-.7c-.179-.579.056-.889.833-1.919.642-.85 1.837-2.433 3.839-5.327a7.389 7.389 0 0 0 1.188-2.422l.036-.322a2.222 2.222 0 0 0 -4.408-.39 1 1 0 1 1 -1.962-.381 4.222 4.222 0 0 1 8.371.823c0 .109-.012.139-.071.618a9.226 9.226 0 0 1 -1.509 3.212c-1.693 2.447-2.817 3.969-3.52 4.906 1.239 0 2.987-.007 4.621-.028a1.03 1.03 0 0 1 1.013.987 1 1 0 0 1 -.987 1.012zm11.625-3.808h-.771c-.009 1.41-.018 2.508-.021 2.845a1 1 0 0 1 -1 .992h-.008a1 1 0 0 1 -.991-1.008c.007-.86.015-1.826.021-2.829h-5.3a1 1 0 0 1 -.882-1.472c.707-1.321 4.269-7.958 4.98-8.858a1.73 1.73 0 0 1 3.206.987c.037.468.025 4.135 0 7.343h.766a1 1 0 0 1 0 2zm13 3.837a1 1 0 0 1 -1-1l-.019-4.462c.016-2.773-.851-3.2-2.248-3.2-1.609 0-2.733 1.314-2.733 3.2v4.462a1 1 0 0 1 -2 0v-13a1 1 0 0 1 2 0v4.218a4.554 4.554 0 0 1 2.733-.877c3.136 0 4.268 2.067 4.248 5.2l.019 4.459a1 1 0 0 1 -1 1z" />
								<path class="srv_1" d="m35.606 41.163h3.636c.017-2.726.026-5.371.015-6.561-.741 1.225-2.345 4.143-3.651 6.561z" />
								<path class="srv_2" d="m34.868 35.5a1 1 0 0 0 -.372-1.364l-6.496-3.716v-13.42a1 1 0 0 0 -2 0v14a1.167 1.167 0 0 0 .5.868l7 4a1 1 0 0 0 1.368-.368z"/>
								<path class="srv_2" d="m48.017 12.456a1 1 0 1 0 -1.68 1.085 23.055 23.055 0 1 1 -3.85-4.541h-1.487a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -2 0v1.68a24.888 24.888 0 1 0 4.017 4.776z"/><path class="srv_2" d="m27 9a1 1 0 0 0 1-1v-2a1 1 0 0 0 -2 0v2a1 1 0 0 0 1 1z"/><path class="srv_2" d="m26 44v2a1 1 0 0 0 2 0v-2a1 1 0 0 0 -2 0z"/><path class="srv_2" d="m44 26a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 -1 1z"/><path class="srv_2" d="m7 25a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"/></svg></div>
							<h3>Doctor Advices</h3>
							<p>Pellentesque sit amet vesti.</p>
						</div>
					</div>
					<div class="mdc_services_item col-12 col-md-4">
						<div class="mdc_item_inner">
						<div class="mdc_item_inner_a"><svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
								<path class="srv_1" d="m39 17a23 23 0 1 0 23 23 23.026 23.026 0 0 0 -23-23zm-8.625 29.971c-1.792.022-3.095.031-4.047.031a11.291 11.291 0 0 1 -2.708-.1 1.141 1.141 0 0 1 -.689-.7c-.179-.579.056-.889.833-1.919.642-.85 1.837-2.433 3.839-5.327a7.389 7.389 0 0 0 1.188-2.422l.036-.322a2.222 2.222 0 0 0 -4.408-.39 1 1 0 1 1 -1.962-.381 4.222 4.222 0 0 1 8.371.823c0 .109-.012.139-.071.618a9.226 9.226 0 0 1 -1.509 3.212c-1.693 2.447-2.817 3.969-3.52 4.906 1.239 0 2.987-.007 4.621-.028a1.03 1.03 0 0 1 1.013.987 1 1 0 0 1 -.987 1.012zm11.625-3.808h-.771c-.009 1.41-.018 2.508-.021 2.845a1 1 0 0 1 -1 .992h-.008a1 1 0 0 1 -.991-1.008c.007-.86.015-1.826.021-2.829h-5.3a1 1 0 0 1 -.882-1.472c.707-1.321 4.269-7.958 4.98-8.858a1.73 1.73 0 0 1 3.206.987c.037.468.025 4.135 0 7.343h.766a1 1 0 0 1 0 2zm13 3.837a1 1 0 0 1 -1-1l-.019-4.462c.016-2.773-.851-3.2-2.248-3.2-1.609 0-2.733 1.314-2.733 3.2v4.462a1 1 0 0 1 -2 0v-13a1 1 0 0 1 2 0v4.218a4.554 4.554 0 0 1 2.733-.877c3.136 0 4.268 2.067 4.248 5.2l.019 4.459a1 1 0 0 1 -1 1z" />
								<path class="srv_1" d="m35.606 41.163h3.636c.017-2.726.026-5.371.015-6.561-.741 1.225-2.345 4.143-3.651 6.561z" />
								<path class="srv_2" d="m34.868 35.5a1 1 0 0 0 -.372-1.364l-6.496-3.716v-13.42a1 1 0 0 0 -2 0v14a1.167 1.167 0 0 0 .5.868l7 4a1 1 0 0 0 1.368-.368z"/>
								<path class="srv_2" d="m48.017 12.456a1 1 0 1 0 -1.68 1.085 23.055 23.055 0 1 1 -3.85-4.541h-1.487a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -2 0v1.68a24.888 24.888 0 1 0 4.017 4.776z"/><path class="srv_2" d="m27 9a1 1 0 0 0 1-1v-2a1 1 0 0 0 -2 0v2a1 1 0 0 0 1 1z"/><path class="srv_2" d="m26 44v2a1 1 0 0 0 2 0v-2a1 1 0 0 0 -2 0z"/><path class="srv_2" d="m44 26a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 -1 1z"/><path class="srv_2" d="m7 25a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"/></svg></div>
							<h3>Professional treated</h3>
							<p>Suspendisse ac felis non.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
			
		<div className="mdc_team mb">
                    <div className="mdc-title">
                        <h2>Our Professionals</h2>
                    </div>
					<div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="team_inner">
                                <div class="team_inner_a">
                                    <img src={require("../../images/doctor_1.png")} /></div>
                                    <h3>Dr Suspendisse cursus</h3>
                                    <span>Surgeon</span>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="team_inner">
                                <div class="team_inner_a"><img src={require("../../images/doctor_2.png")} /></div>
                                    <h3>Dr Nunc eleifend</h3>
                                    <span>Nurse</span>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="team_inner">
                                <div class="team_inner_a"><img src={require("../../images/doctor_3.png")} /></div>
                                    <h3>Dr Morbi convallis</h3>
                                    <span>Surgeon</span>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="team_inner">
                                <div class="team_inner_a"><img src={require("../../images/doctor_1.png")} /></div>
                                    <h3>Dr Duis nec</h3>
                                    <span>Assistance</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="free_consultancy w-left">
                    <div className="container">
                        <div className="row">
                            <div className="free_consult_inner">
                                <div className="fc_left col-12 col-lg-3">
                                    <h3>Get Free Consultany</h3>
                                    <p><span>Call to</span><a href=":tel">+(9)677-788-8788</a></p>
                                </div>
                                <div className="fc_right col-12 col-lg-9">
                                    <form action="" method="">
                                        <input type="email" name="your email" placeholder="Your Email" />
                                        <input type="text" name="your name" placeholder="Your Name" />
                                        <input type="button" value="Get it Now" />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   
        </PageWrapper>
    );
}
export default Treatment;